import * as React from 'react';

import { Title } from '../../offer-card/components/title';

import * as styles from './TopTitle.css';

/**
 * Блок названия объявления для царь-карточки
 *
 * По отношению к базовому блоку (Title) добавлен заголовок объявления и увеличен шрифт
 */
export class TopTitle extends Title {
  public render() {
    const offerTitle = this.context.offerHelper.presenters.getOfferTitle();
    const { isDealRentCianAgency } = this.props;

    const offerName = [
      this.getType(),
      this.renderArea(),
      this.renderFloor(),
      this.renderFoolrsForSuburban(),
      this.renderBedroomCount(),
      ]
      .filter(Boolean)
      .join(', ');

    if (offerTitle) {
      return (
        <div className={styles['title_wrapper']}>
          <div className={styles['title']}>
            {isDealRentCianAgency ? 'Прямая аренда от Циан' : offerTitle}
          </div>
          <div className={styles['subtitle']}>
            {offerName}
          </div>
        </div>
      );
    }

    return (
      <div className={styles['single_title']}>
        {offerName}
      </div>
    );
  }
}
